module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#FCFDFD",
      "margin": "0",
      "padding": "0.5em",
      "padding-left": "0.5em",
      "padding-top": "0.1em",
      "border-bottom": "none",
      "border": "none"
    }
  }, [_c('li', {
    staticClass: "header-left-2",
    staticStyle: {
      "min-width": "40%",
      "max-width": "45%"
    }
  }, [(_vm.can_show_back_nav) ? _c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.can_show_side_nav) ? _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (this.$route.path == '/settings') ? _c('div', [(_vm.site_user_type == 2) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em 0.31em",
      "margin-bottom": "-1.92em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _vm._v(" " + _vm._s(_vm.set_str_attr.business.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sellpoint.business_name) ? _c('li', {
    staticStyle: {
      "padding-top": "0.6em"
    }
  }, [_c('a', {
    staticClass: "card-link prd-name-1-line-clip",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.sellpoint.business_name))])])]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.sellpoints).length > 1)) ? _c('li', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('showBusinesses')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "18px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('div', [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "38px",
      "margin-left": "1em",
      "margin-top": "-1.86em"
    },
    attrs: {
      "src": "/static/assets/images/brand002.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticStyle: {
      "clear": "both",
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "cursor": "pointer",
      "margin-top": "-0.4em",
      "padding-top": "0px",
      "float": "right"
    },
    attrs: {
      "href": "/settings/profile"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.16em 0.21em"
    }
  }, [_c('i', {
    staticClass: "fas fa-user",
    staticStyle: {
      "font-size": "1.18em"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc9ab09"}!./src/pages/MainHeader/template.html
// module id = 593
// module chunks = 0